import React, {useEffect, useState, useMemo} from "react";
import { isDesktop } from "react-device-detect";
import objectPath from "object-path";
import { onAxiosApiCall, useLocalStorage, getLanguage } from "../../../../utils";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import styles from './brand.module.css';
import { API_URL, PWA_URL } from "../../../../constants";

export function Brand() {
  const uiService = useHtmlClassService();
  const [localStorageData] = useLocalStorage("clientpanel");

  const layoutProps = useMemo(() => {
    return {
      brandClasses: uiService.getClasses("brand", true),
      asideSelfMinimizeToggle: objectPath.get(
          uiService.config,
          "aside.self.minimize.toggle"
      ),
      headerLogo: uiService.getLogo(),
      headerStickyLogo: uiService.getStickyLogo()
    };
  }, [uiService]);
  const [clientPanelContent, setClientPanelContent] = useState("");
  const language = getLanguage(navigator.language, localStorageData);

  const gotToPwaApp = () => {
    if (localStorageData !== null && localStorageData !== "") {
      window.location.assign(`${PWA_URL}${localStorageData.pwa_config2.pwa}/owner/authenticate-to-pwa/${localStorageData.pwa_token}`);
    }
  }

  useEffect(() => {
    const section = "login_screen,messages";
    onAxiosApiCall(API_URL + language + "/get-client-panel-content/" + section, "GET", "")
    .then((response) => {
      if (response.status === 200) {
        if (response.data['login_screen'] !== undefined && response.data['login_screen'] !== null && response.data['login_screen'] !== "") {
          setClientPanelContent(response.data['login_screen']);
        } else {
          setClientPanelContent("");
        }
      }
    });
  }, []);
  return (
    <>
      {/* begin::Brand */}
      {!isDesktop && <div  id="go_to_app" className="d-flex flex-wrap justify-content-start align-items-center mr-10-25">
        <button className="go-to-app-after-login border-0" onClick={gotToPwaApp} style={{background: 'none'}}><svg width="7" height="9" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.28027 0.94L2.22027 4L5.28027 7.06L4.33361 8L0.333607 4L4.33361 -4.13801e-08L5.28027 0.94Z" fill="#fff"/>
          </svg> {clientPanelContent !== undefined && clientPanelContent !== "" && clientPanelContent.go_to_app_btn_text !== undefined && clientPanelContent.go_to_app_btn_text !== "" ? clientPanelContent.go_to_app_btn_text : ""}
        </button>
      </div>}
      <div
        className={`brand flex-column-auto ${layoutProps.brandClasses} ${styles.clientInfo}`}
        id="kt_brand"
      >
        {/* begin::Logo */}
        {localStorageData !== null && localStorageData !== "" && <img className={`${styles.clientLogo}`} id="show_client_logo" alt="logo" src={localStorageData.logo} />}
        
        {/* end::Logo */}
        {localStorageData !== null && localStorageData !== "" && localStorageData.company_brand_name !== "" && <h2 className={`${styles.clientName}`}>{localStorageData.company_brand_name}</h2>}
        {layoutProps.asideSelfMinimizeToggle && (
          <>
            {/* begin::Toggle */}
            {/* <button className="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
              <span className="svg-icon svg-icon-xl">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-double-left.svg")}/>
              </span>
            </button> */}
            {/* end::Toolbar */}
            </>
        )}
      </div>
      {/* end::Brand */}
      </>
  );
}
